module.exports = __webpack_public_path__ + "img/Frame6592S.ef349274.svg";